import { ApiConfigService } from '@nextgen-web-framework/core';

type FetchRequestOptions = {
  url: string;
  method?: string;
  headers?: Record<string, string>;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  body?: any;
};

const request = async <T>(options: FetchRequestOptions): Promise<T> => {
  const baseURL = ApiConfigService.getBaseUrl();
  const url = options.url.startsWith('http') ? options.url : `${baseURL}${options.url}`;

  const tuples = ApiConfigService.getTuples() || {};
  const headers = {
    'Content-Type': 'application/json',
    ...tuples,
    ...options.headers,
  };

  const fetchOptions: RequestInit = {
    method: options.method ?? 'GET',
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  };

  const response = await fetch(url, fetchOptions);

  if (!response.ok) {
    throw new Error(`Fetch Request failed with status ${response.status}`);
  }

  return response.json() as Promise<T>;
};

export { request };
